import { API } from 'Core'
import { populateActionObjects } from 'Utils/ActionEnpointsHelper'
import { populateAuthZ } from 'Utils/ActionZActionCheckHelper'
import { sliceGenerator } from './sliceGenerator'

export const userListSlice = sliceGenerator({
  sliceName: 'userList',
  endpoint: 'users',
  initialState: []
})
export const proxiesSlice = sliceGenerator({
  sliceName: 'proxyList',
  endpoint: 'proxies',
  initialState: []
})
export const groupListSlice = sliceGenerator({
  sliceName: 'groupList',
  endpoint: 'groups',
  initialState: []
})
export const serviceAccountsSlice = sliceGenerator({
  sliceName: 'serviceAccounts',
  endpoint: 'serviceaccounts',
  initialState: []
})
export const projectsSlice = sliceGenerator({
  sliceName: 'projects',
  endpoint: 'projects',
  initialState: []
})
export const idpListSlice = sliceGenerator({
  sliceName: 'idpList',
  endpoint: 'idproviders',
  initialState: []
})
export const policySlice = sliceGenerator({
  sliceName: 'policyList',
  endpoint: 'pacpolicys',
  initialState: []
})
export const paaPolicySlice = sliceGenerator({
  sliceName: 'paaPolicyList',
  endpoint: 'paapolicys',
  initialState: []
})
export const deviceListSlice = sliceGenerator({
  sliceName: 'deviceList',
  endpoint: 'devices',
  initialState: []
})
export const serverListSlice = sliceGenerator({
  sliceName: 'serverList',
  endpoint: 'servers',
  initialState: []
})
export const vpcListSlice = sliceGenerator({
  sliceName: 'vpcList',
  endpoint: 'vpcs',
  initialState: []
})
export const accountListSlice = sliceGenerator({
  sliceName: 'accountList',
  endpoint: 'accounts',
  initialState: []
})
export const iamActionsSlice = sliceGenerator({
  sliceName: 'iamActions',
  endpoint: 'iamactions',
  initialState: []
})
export const gcpResources = sliceGenerator({
  sliceName: 'gcpResources',
  endpoint: 'gcpresources',
  initialState: []
})
export const azureResourcesSlice = sliceGenerator({
  sliceName: 'azureResources',
  endpoint: 'azureresources',
  initialState: []
})
export const appRolesListSlice = sliceGenerator({
  sliceName: 'appRolesList',
  endpoint: 'approles',
  initialState: []
})
export const medusaNodesSlice = sliceGenerator({
  sliceName: 'medusaNodes',
  endpoint: 'medusanodes',
  initialState: []
})
export const jiraProject = sliceGenerator({
  sliceName: 'jiraProjectList',
  endpoint: 'jiraprojects',
  initialState: []
})
export const recordingListSlice = sliceGenerator({
  sliceName: 'recordingList',
  endpoint: 'recordings',
  initialState: []
})
export const awsResourcesSlice = sliceGenerator({
  sliceName: 'awsResources',
  endpoint: 'awsresources',
  initialState: []
})
export const slackChannel = sliceGenerator({
  sliceName: 'slackChannelList',
  endpoint: 'slackchannels',
  initialState: []
})
export const integrationSlice = sliceGenerator({
  sliceName: 'integrationsList',
  endpoint: 'integrations',
  initialState: []
})
export const approvalReqListSlice = sliceGenerator({
  sliceName: 'approvalReqList',
  endpoint: 'approvalreqs',
  initialState: []
})
export const applicationListSlice = sliceGenerator({
  sliceName: 'applicationList',
  endpoint: 'applications',
  initialState: []
})
export const googleIdpListSlice = sliceGenerator({
  sliceName: 'googleIdpList',
  endpoint: 'googleidproviders',
  initialState: []
})
export const userAccountsListSlice = sliceGenerator({
  sliceName: 'userAccountsList',
  endpoint: 'useraccounts',
  initialState: []
})
export const jiraIntegrations = sliceGenerator({
  sliceName: 'jiraIntegrationsList',
  endpoint: 'jiraintegrations',
  initialState: []
})
export const JiraIssueTypesSlice = sliceGenerator({
  sliceName: 'jiraIssue',
  endpoint: 'jiraissue',
  initialState: []
})
export const slackIntegrations = sliceGenerator({
  sliceName: 'slackIntegrationList',
  endpoint: 'slackintegrations',
  initialState: []
})
export const credentialsListSlice = sliceGenerator({
  sliceName: 'credentialsList',
  endpoint: 'credentials',
  initialState: []
})
export const serverGroupListSlice = sliceGenerator({
  sliceName: 'serverGroupList',
  endpoint: 'servergroups',
  initialState: []
})

export const credentialTypeSlice = sliceGenerator({
  sliceName: 'credentialTypesList',
  endpoint: null,
  initialState: [],
  apiFn: API.getCredentialTypesList
})
export const credentialInstanceSlice = sliceGenerator({
  sliceName: 'credentialInstanceList',
  endpoint: null,
  initialState: [],
  apiFn: API.getCredentialInstanceList
})
export const resourceActionsSlice = sliceGenerator({
  sliceName: 'resourceActions',
  endpoint: null,
  initialState: {},
  apiFn: populateActionObjects
})
export const resourceKindGrantsSlice = sliceGenerator({
  sliceName: 'resourceKindGrants',
  endpoint: null,
  initialState: {},
  apiFn: populateAuthZ
})
export const userpreferencesSlice = sliceGenerator({
  sliceName: 'userPreferences',
  endpoint: null,
  initialState: [],
  apiFn: API.fetchUserPreference
})
export const tenantprofilesSlice = sliceGenerator({
  sliceName: 'tenantprofiles',
  endpoint: 'tenantprofiles',
  initialState: {},
  apiFn: API.getTenantprofiles
})

export const tenantsiemconfigsSlice = sliceGenerator({
  sliceName: 'tenantsiemconfigs',
  endpoint: 'tenantsiemconfigs',
  initialState: {}
})

export const databaseSlice = sliceGenerator({
  sliceName: 'databases',
  endpoint: 'databases',
  initialState: []
})
export const kubeNamespacesSlice = sliceGenerator({
  sliceName: 'kubeNamespaces',
  endpoint: 'kubenamespaces',
  initialState: []
})
export const githubresourcesSlice = sliceGenerator({
  sliceName: 'githubResources',
  // Endpoint was githubresources; the backend renamed the kind to ScmResource
  // (githubresource.proto -> scm_resource.proto) and the old route no longer
  // exists — the 401s that got this stubbed were that. Same objects, same shape
  // (Spec.Type repository/team, RepositorySpec/TeamSpec, Account ref).
  endpoint: 'scmresources',
  initialState: []
})

export const githubAccountSlice = sliceGenerator({
  sliceName: 'githubAccount',
  // Renamed to scm-account on the backend (scm_account.proto).
  endpoint: 'scm-account',
  initialState: []
})

export const tagPolicySlice = sliceGenerator({
  sliceName: 'tagPolicys',
  endpoint: 'tagpolicys',
  initialState: []
})

export const notificationSubscriptionSlice = sliceGenerator({
  sliceName: 'notificationSubscriptions',
  endpoint: 'notificationsubscriptions',
  initialState: []
})

export const workloadsSlice = sliceGenerator({
  sliceName: 'workloads',
  endpoint: 'workloadidentitys',
  // TODO: re-enable — commented out for now (401s while testing locally)
  // apiFn intentionally stubbed to skip the actual GET /workloadidentitys call
  apiFn: async () => [],
  initialState: []
})

export const approversSlice = sliceGenerator({
  sliceName: 'approvers',
  endpoint: 'approvers',
  initialState: []
})

export const rdpServersSlice = sliceGenerator({
  sliceName: 'rdpServers',
  endpoint: 'rdpservers',
  initialState: []
})

export const kafkas = sliceGenerator({
  sliceName: 'kafkas',
  endpoint: 'kafkas',
  initialState: []
})

export const servicenowintegrations = sliceGenerator({
  sliceName: 'servicenowintegrations',
  endpoint: 'servicenowintegrations',
  initialState: []
})

export const servicenowtables = sliceGenerator({
  sliceName: 'servicenowtables',
  endpoint: 'servicenowtables',
  initialState: []
})

export const kubeClusters = sliceGenerator({
  sliceName: 'kubeClusters',
  endpoint: 'kubeclusters',
  initialState: []
})

export const adDomainControllers = sliceGenerator({
  sliceName: 'adDomainControllers',
  endpoint: 'addomaincontrollers',
  initialState: []
})

export const adPasswords = sliceGenerator({
  sliceName: 'adPasswords',
  endpoint: 'adpasswords',
  initialState: []
})

export const bundles = sliceGenerator({
  sliceName: 'bundles',
  endpoint: 'reqbundles',
  initialState: []
})

export const visibilitys = sliceGenerator({
  sliceName: 'visibilitys',
  endpoint: 'visibilitys',
  initialState: []
})

export const rdppasswords = sliceGenerator({
  sliceName: 'rdppasswords',
  endpoint: 'rdppasswords',
  initialState: []
})

export const salesForceUsersList = sliceGenerator({
  sliceName: 'salesForceUsersList',
  endpoint: 'salesforce-users',
  initialState: []
})

export const salesForcePermissionList = sliceGenerator({
  sliceName: 'salesForcePermissionList',
  endpoint: 'crm-entities',
  initialState: []
})

export const salesForceAccountList = sliceGenerator({
  sliceName: 'salesForceAccountList',
  endpoint: 'salesforce-account',
  initialState: []
})

export const salesForceUserPermissionBinding = sliceGenerator({
  sliceName: 'salesForceUserPermissionBinding',
  endpoint: 'salesforce-user-perm-binding',
  initialState: []
})

export const snowFlakeResources = sliceGenerator({
  sliceName: 'snowFlakeResources',
  endpoint: 'snowflakeresources',
  initialState: []
})

export const snowFlakeRoles = sliceGenerator({
  sliceName: 'snowFlakeRoles',
  endpoint: 'snowflakeroles',
  initialState: []
})

export const snowFlakeAccounts = sliceGenerator({
  sliceName: 'snowFlakeAccounts',
  endpoint: 'snowflakeaccounts',
  initialState: []
})

export const snowFlakeUsers = sliceGenerator({
  sliceName: 'snowFlakeUsers',
  endpoint: 'snowflakeusers',
  initialState: []
})

export const msTeamsIntegrations = sliceGenerator({
  sliceName: 'msTeamsIntegrations',
  endpoint: 'msteamsintegrations',
  initialState: []
})

export const mattermostIntegrations = sliceGenerator({
  sliceName: 'mattermostIntegrations',
  endpoint: 'mattermostintegrations',
  initialState: []
})

export const msTeamsChannels = sliceGenerator({
  sliceName: 'msTeamsChannels',
  endpoint: 'msteamschannels',
  initialState: []
})

export const msTeams = sliceGenerator({
  sliceName: 'msTeams',
  endpoint: 'msteams',
  initialState: []
})

export const dataBricksAccounts = sliceGenerator({
  sliceName: 'dataBricksAccounts',
  endpoint: 'databricksaccounts',
  initialState: []
})

export const dataBricksWorkSpaces = sliceGenerator({
  sliceName: 'dataBricksWorkSpaces',
  endpoint: 'databricksworkspaces',
  initialState: []
})

export const dataBricksIdentitys = sliceGenerator({
  sliceName: 'dataBricksIdentitys',
  endpoint: 'databricksidentitys',
  initialState: []
})

export const dataBricksResources = sliceGenerator({
  sliceName: 'dataBricksResources',
  endpoint: 'databricksresources',
  initialState: []
})

export const iamUsers = sliceGenerator({
  sliceName: 'iamUsers',
  endpoint: 'iamusers',
  initialState: []
})

export const analyzeIdentity = sliceGenerator({
  sliceName: 'analyzeIdentity',
  endpoint: 'analyze-identity',
  initialState: []
})

export const iamGroups = sliceGenerator({
  sliceName: 'iamGroups',
  endpoint: 'iamgroups',
  initialState: []
})

export const iamRoles = sliceGenerator({
  sliceName: 'iamRoles',
  endpoint: 'iamroles',
  initialState: []
})

export const iamFederatedUsers = sliceGenerator({
  sliceName: 'iamFederatedUsers',
  endpoint: 'iamfederatedusers',
  initialState: []
})

export const serverControllers = sliceGenerator({
  sliceName: 'serverControllers',
  endpoint: 'servercontrollers',
  initialState: []
})

export const proxyControllers = sliceGenerator({
  sliceName: 'proxyControllers',
  endpoint: 'proxycontrollers',
  initialState: []
})

export const medusaNodeStates = sliceGenerator({
  sliceName: 'medusaNodeStates',
  endpoint: 'medusanodestates',
  initialState: []
})

export const privateAccounts = sliceGenerator({
  sliceName: 'privateAccounts',
  endpoint: 'privateaccounts',
  initialState: []
})

export const iamServiceAccounts = sliceGenerator({
  sliceName: 'iamServiceAccounts',
  endpoint: 'iamserviceaccounts',
  initialState: []
})

export const userCredentials = sliceGenerator({
  sliceName: 'userCredentials',
  endpoint: 'user-credentials',
  initialState: []
})

export const resourceTypes = sliceGenerator({
  sliceName: 'resourceTypes',
  endpoint: 'resourcetypes',
  initialState: []
})

export const gsuiteListSlice = sliceGenerator({
  sliceName: 'gsuiteList',
  endpoint: 'gsuites',
  initialState: []
})

export const nonHumanIdentityListSlice = sliceGenerator({
  sliceName: 'nonHumanIdentityList',
  endpoint: 'nonhumanidentities',
  initialState: []
})

export const shadowAIListSlice = sliceGenerator({
  sliceName: 'shadowAIList',
  endpoint: 'shadowai',
  initialState: []
})

export const shadowAIPolicyListSlice = sliceGenerator({
  sliceName: 'shadowAIPolicyList',
  endpoint: 'shadowaipolicys',
  initialState: []
})

export const secretStoreAccountsSlice = sliceGenerator({
  sliceName: 'secretStoreAccounts',
  endpoint: 'secretstoreaccounts',
  initialState: []
})

export const secretsSlice = sliceGenerator({
  sliceName: 'secrets',
  endpoint: 'secrets',
  initialState: []
})

export const secretTemplatesSlice = sliceGenerator({
  sliceName: 'secretTemplates',
  endpoint: 'secrettemplates',
  initialState: []
})

export const cloudAgentsSlice = sliceGenerator({
  sliceName: 'cloudagents',
  endpoint: 'cloudagents',
  initialState: []
})

export const aiAgentAccountsSlice = sliceGenerator({
  sliceName: 'aiagentaccounts',
  endpoint: 'aiagentaccounts',
  initialState: []
})

export const agentAccessKeysSlice = sliceGenerator({
  sliceName: 'agentAccessKeys',
  endpoint: 'agentaccesskeys',
  initialState: []
})

export const aiPolicyListSlice = sliceGenerator({
  sliceName: 'aiPolicyList',
  endpoint: 'aipolicys',
  initialState: []
})

export const aiIntentListSlice = sliceGenerator({
  sliceName: 'aiIntentList',
  endpoint: 'aiintents',
  initialState: []
})

export const agentApprovalListSlice = sliceGenerator({
  sliceName: 'agentApprovalList',
  endpoint: 'agentapprovals',
  initialState: []
})

export const agentKeyUsageSlice = sliceGenerator({
  sliceName: 'agentKeyUsage',
  endpoint: 'agentkeyusage',
  initialState: []
})

export const userVaultSlice = sliceGenerator({
  sliceName: 'uservaults',
  endpoint: 'uservaults',
  initialState: {}
})

// Durable receipts for granted platform access — one per (platform, account,
// target, principal, permission) tuple issued by a policy. State is
// Granted / RevokePending / Failed / Orphaned (Orphaned = drift: the platform
// disagrees with the receipt). Serves the Access tab's Drift view.
export const accessGrantSlice = sliceGenerator({
  sliceName: 'accessGrants',
  endpoint: 'access-grants',
  initialState: []
})
